import React, { useEffect, useState } from 'react';
import { useAppSelector } from '../../../state/hooks';
import { SociologicalResearchPartnersStyles } from './styles';
import { partnersGreenTheme } from './utils';
import Marquee from 'react-fast-marquee';
import getTranslationsByLangOrEng from '../../../utils/getTranslationsByLangOrLang';

export const SociologicalResearchPartners = () => {
  const { interfaceLanguage } = useAppSelector((state) => state.languages);

  const [data, setData] = useState<{ static: string; alt: string }[]>();

  useEffect(() => {
    setData([
      ...partnersGreenTheme,
    ]);
  }, []);

  return (
    <SociologicalResearchPartnersStyles>
      <h1>{getTranslationsByLangOrEng(interfaceLanguage, 'sociological_research_4')}</h1>
      <div className="partner-quee">
        {data && (
          <Marquee speed={window.innerWidth > 1000 ? 100 : 120}>
            {data.map((item, index) => (
              <div className="logoWrapper" key={item.alt}>
                <img src={item.static} alt={item.alt} />
              </div>
            ))}
          </Marquee>
        )}
      </div>
    </SociologicalResearchPartnersStyles>
  );
};
